import { Component } from '@angular/core';
import { AuthService } from './core';
import { ApmService } from '@elastic/apm-rum-angular';
import { SharedService } from './shared/services/shared.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent {

    hasAuth: any;
    hideSideBar: boolean = false;

    constructor(
        private authService: AuthService,
        private apmService: ApmService,
        private sharedService: SharedService,
    ) { }

    ngOnInit() {
        this.hasAuth = !!this.authService.token && !!this.authService.user;
        this.authService.hasAuthentication().subscribe((user: any) => this.hasAuth = !!user);

        const transaction = this.apmService.apm.startTransaction('sisdio-web', 'init-app');
        transaction?.end();

        this.sharedService.currentValue.subscribe(value => {
            this.hideSideBar = value;            
        });
    }

}
